import { render, staticRenderFns } from "./IpoAllocatedLists.vue?vue&type=template&id=1dfe0eb0"
import script from "./IpoAllocatedLists.vue?vue&type=script&lang=js"
export * from "./IpoAllocatedLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports